<template>
  <div>
    <preview-vap
      ref="previewVapInstance"
      @on-start="emit('onStart')"
      @on-end="emit('onEnd')"
    ></preview-vap>
    <preview-svga
      ref="previewSvgaInstance"
      @on-start="emit('onStart')"
      @on-end="emit('onEnd')"
    ></preview-svga>
  </div>
</template>

<!-- Vap/svga预览组件整合 -->
<script setup lang="ts">
import PreviewVap from './PreviewEffectVap.vue'
import PreviewSvga from './PreviewEffectSvga.vue'
import type { OpenVapOptions, PreviewOptions } from '@/types/vap.d.ts'

const emit = defineEmits(['onEnd', 'onStart'])

// 预览vap实例
const previewVapInstance = ref<InstanceType<typeof PreviewVap>>()
// 预览Svga实例
const previewSvgaInstance = ref<InstanceType<typeof PreviewSvga>>()

/**
 * 预览Vap/MP4动效
 */
const preview = (options: PreviewOptions) => {
  if (options.svgaUrl) {
    previewSvgaInstance.value?.openSvga(options.svgaUrl)
  } else if (options.vapUrl) {
    previewVapInstance.value?.openVap(options as OpenVapOptions)
  }
}

defineExpose({
  preview
})
</script>

<style scoped lang="scss"></style>
